import React from 'react';
import Modal from 'simple-react-modal';
import { Formik, Form, ErrorMessage } from 'formik';
import Loading from 'react-simple-loading';

import './EditVideo.css';
import '../../../../../css/utils/flex.css';

class EditVideo extends React.Component {

  formContainerRef = React.createRef();

  componentDidMount () {
    this.formContainerRef.current.focus();
  }

  onContainerKeyDown = event => {
    if (event.keyCode === 27 && event.target.tagName === 'DIV') {
      this.props.onClose(null);
    }
  }

  validate = values => {
    const errors = {};
    if (!values.title) {
      errors.title = 'Title cannot be empty';
    }
    if (!values.description) {
      errors.description = 'Description cannot be empty';
    }
    return errors;
  }

  render () {
    const { onClose, video, editVideo } = this.props;
    const initialValues = { title: video.title, description: video.description };
    return (
      <Modal
        onClose={() => onClose(null)}
        show={true}
        containerStyle={{ width: '600px' }}
        containerClassName="modal-container">
        <div
          id="edit-anchor-video"
          tabIndex={1}
          ref={this.formContainerRef}
          onKeyDown={this.onContainerKeyDown}>
          <h3 className="modal-title">Edit Video</h3>
          <Formik
            initialValues={initialValues}
            onSubmit={editVideo}
            validate={this.validate}
            render={props => {
              let submitButtonStyles = {};
              if (props.dirty && (!props.isValid || props.isSubmitting)) {
                submitButtonStyles = {
                  opacity: '.4',
                  cursor: 'not-allowed'
                };
              }
              return (
                <Form autoComplete={'off'} className="edit-form">
                  <div className="form-group">
                    <label htmlFor="anchor-video-edit-title">Video Title</label>
                    <input
                      id="anchor-video-edit-title"
                      placeholder="Video title"
                      name="title"
                      value={props.values.title}
                      onChange={props.handleChange}
                    />
                    <div className="error">
                      <ErrorMessage name="title" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="anchor-video-edit-desc">Description</label>
                    <textarea
                      id="anchor-video-edit-desc"
                      value={props.values.description}
                      name="description"
                      onChange={props.handleChange}
                    />
                    <div className="error">
                      <ErrorMessage name="description" />
                    </div>
                  </div>
                  <div className="buttons">
                    <button
                      disabled={props.isSubmitting}
                      style={submitButtonStyles}
                      type="submit"
                      className="submit-button">
                      Save changes
                    </button>
                    <button
                      type="button"
                      onClick={() => onClose(null)}
                      className="cancel-button">
                      Cancel
                    </button>
                  </div>
                  {!props.isValidating && props.isSubmitting && (
                    <div>
                      <Loading size={'32px'} stroke={'2px'} />
                    </div>
                  )}
                </Form>
              );
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default EditVideo;